import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { SiteData } from '../types/data';
import locksmithWork from '../assets/locksmith-work.jpg';

interface AboutProps {
  data: SiteData['about'];
}

export const About = ({ data }: AboutProps) => {
  return (
    <section id="o-nas" className="py-20 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          <div className="lg:w-1/2">
            <div className="relative">
              <img 
                src={locksmithWork} 
                alt="Zámečník při práci" 
                className="rounded-2xl shadow-2xl w-full max-w-md mx-auto lg:max-w-full"
              />
              <div className="absolute -bottom-6 -right-6 bg-primary text-white p-8 rounded-2xl hidden md:block">
                <p className="text-4xl font-bold mb-1">{data.badgeValue}</p>
                <p className="text-sm font-medium opacity-90">{data.badgeLabel}</p>
              </div>
            </div>
          </div>
          
          <div className="lg:w-1/2">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              {data.title}
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              {data.description}
            </p>
            
            <div className="space-y-4">
              {data.features.map((item, index) => (
                <div key={index} className="flex items-start gap-3">
                  <CheckCircle2 className="w-6 h-6 text-secondary flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700 font-medium">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
